import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5b23b18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-overlay tw-mt-4 tw-pt-4 tw-box-border tw-border-t-solid-custom" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-1 tw-items-start tw-pb-4" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-1 tw-items-start" }
const _hoisted_6 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-0 tw-items-start" }
const _hoisted_7 = { class: "tw-flex tw-flex-col tw-gap-0 tw-items-start" }
const _hoisted_8 = { class: "tw-mt-2 tw-mb-4 tw-w-full tw-h-auto tw-flex tw-flex-col tw-gap-4 tw-p-3 tw-box-border tw-border-[1px] tw-border-[#DFDFDF] tw-border-solid tw-rounded-[8px] tw-bg-[#F8FBFD]" }
const _hoisted_9 = { class: "upload__section md:!tw-h-[100px]" }
const _hoisted_10 = { class: "uploade-wrapper custom-file-upload !tw-h-[97px] md:!tw-h-full !tw-w-full !tw-mt-4 !tw-rounded-lg !tw-mb-4" }
const _hoisted_11 = {
  key: 0,
  class: "attachment-list !tw-mt-0"
}
const _hoisted_12 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_13 = { class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-pb-4 tw-gap-4" }
const _hoisted_14 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-0 rmd:!tw-gap-1" }
const _hoisted_15 = {
  key: 0,
  class: "w-full sm:w-80 tw-py-4"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "  Uploading file(s)...", -1))
const _hoisted_17 = { class: "modal-footer" }

import moment from "moment";
import { ref, computed, onMounted } from "vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import { getCurrentInstance } from "@vue/runtime-core";
import { displayToastMessage } from "@/core/utils/common";
import { USER_STORE } from "@/store/modules/user";
import { WORKSTATION } from "@/store/modules/workstation";
import { useStore } from "vuex";
import { PROJECT_STORE } from "@/store/modules/project";
import PdfIcon from "@/core/components/icons/PdfIcon.vue";
import ImageIcon from "@/core/components/icons/ImageIcon.vue";
import Text from "@/core/components/ui/general/Text.vue";
import InputField from "@/core/components/common/InputField.vue";
import { DATE_FORMAT } from "@/core/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddOrEditDbsCheckModal',
  props: ["dbsModalType", "selectedDbsData"],
  emits: ["on-close", "on-submit", "on-success"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emits = __emit;
const props = __props;

const internalInstance = getCurrentInstance();
const formRef = ref<any>(null);
const isUploadImg = ref<boolean>(false);

const validation = ref({
  issueDate: [(v: string) => !!v || "Enter DBS Check issue date"],
  attachments: [
    (v: any[]) => v.length > 0 || "At least one attachment is required",
  ],
});

const issueDate = ref("");
const selectedAttachments = ref<any[]>([]);

const isFileUploading = ref(false);
const attachmentError = ref("");
const uploadProgress = ref(0);
const imageData = ref("");
const qualificationData = ref({
  certificateId: null,
  registrationNumber: null,
  url: null,
  attachments: [],
}) as any;

const user = computed(() => store.getters[`${USER_STORE}/user`]);
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const onFileChangeAttachments = async (event: any) => {
  try {
    isFileUploading.value = true;
    attachmentError.value = "";
    uploadProgress.value = 0;

    const fileInput = event.target;
    if (fileInput.files && fileInput.files.length > 0) {
      const files = Array.from(fileInput.files);
      let progressInterval: any;

      // Add new files if they don't already exist
      files.forEach((file: any) => {
        if (!selectedAttachments.value.some((doc) => doc.name === file.name)) {
          selectedAttachments.value.push(file);
        }
      });

      // Ensure there's at least one file to upload before starting progress
      if (selectedAttachments.value.length) {
        console.log("Uploading started...");

        progressInterval = setInterval(() => {
          if (uploadProgress.value < 100) {
            uploadProgress.value += 10;
          } else {
            clearInterval(progressInterval);
          }
        }, 200);

        // Simulate async upload time
        await new Promise((resolve) => setTimeout(resolve, 2200));

        clearInterval(progressInterval);
        uploadProgress.value = 100;
      }

      event.target.value = "";
      console.log(selectedAttachments.value, "selectedAttachments.value");
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    attachmentError.value = "Error uploading file.";
  } finally {
    setTimeout(() => {
      isFileUploading.value = false;
    }, 500); // Delay hiding the loader to ensure UI updates properly
  }
};

const onSubmit = async () => {
  const isFormValid = await formRef.value.validate();

  if (!isFormValid.valid) return;

  try {
    isUploadImg.value = true;
    // const attachments = [] as any;
    let payload = {} as any;
    let logo = "";
    let attachments = [] as any;

    for (const attachment of selectedAttachments.value) {
      const formData = new FormData();
      formData.append("file", attachment);
      const uploadImg = await store.dispatch(
        `${USER_STORE}/uploadProfileImage`,
        formData
      );

      if (uploadImg?.publicUrl) {
        attachments.push(uploadImg);
      } else {
        displayToastMessage(
          internalInstance,
          "Failed to upload an attachment.",
          "error"
        );
      }
    }

    console.log(payload, "payload");

    if (props.dbsModalType === "add") {
      payload = {
        metadata: {
          issueDate: moment(issueDate.value, "DD-MM-YYYY").toISOString(), // Convert to ISO 8601 format
        },
        userId: user.value?.id,
        attachments,
      };

      const request = {
        userId: user.value?.id,
        payload,
      };

      console.log(request, "request");

      const response = await store.dispatch(
        `${USER_STORE}/addTradePassportDbs`,
        request
      );

      console.log(response, "response");

      if (response) {
        emits("on-success");
      }
    }

    if (props.dbsModalType === "edit") {
      const attachment = {
        ...attachments[0],
        id: props.selectedDbsData?.attachment[
          props.selectedDbsData?.attachment.length - 1
        ].id,
      };
      payload = {
        metadata: {
          issueDate: moment(issueDate.value, "DD-MM-YYYY").toISOString(), // Convert to ISO 8601 format
        },
        userVerificationStatus: props.selectedDbsData?.userVerificationStatus,
        attachment,
      };

      const request = {
        userId: user.value?.id,
        id: props.selectedDbsData?.id,
        payload,
      };

      console.log(request, "request");

      const response = await store.dispatch(
        `${USER_STORE}/updateTradePassportDbsById`,
        request
      );

      console.log(response, "response");

      if (response) {
        emits("on-success");
      }
    }

    // store.dispatch(`${WORKSTATION}/setActiveUserWorkstation`);

    // console.log(response, "response");

    // emits("on-submit", { userMessageContent, disputeOffer });
  } catch (error: any) {
    if (error.response) {
      if (error.response.status) {
        const errorMessage =
          error.response.data.message || "An error occurred. Please try again.";
        displayToastMessage(internalInstance, errorMessage, "error");
      } else {
        // Handle other status codes or errors
        displayToastMessage(
          internalInstance,
          `Error: ${error.response.statusText}`,
          "error"
        );
      }
    } else {
      displayToastMessage(
        internalInstance,
        "The request took too long and timed out. Please try again later.",
        "error"
      );
    }
  } finally {
    isUploadImg.value = false;
    issueDate.value = "";
    selectedAttachments.value = [];
    onClickBackButton();
  }
};

const removeAttachment = (index: number) => {
  selectedAttachments.value.splice(index, 1);
};

const onClickBackButton = () => {
  issueDate.value = "";
  selectedAttachments.value = [];
  return emits("on-close");
};

const formatIssueDate = (isoDate: any) => {
  return new Date(isoDate).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

onMounted(() => {
  if (props.selectedDbsData) {
    console.log(props.selectedDbsData, "selectedDbsData");
    issueDate.value = formatIssueDate(
      props.selectedDbsData?.metadata?.issueDate
    );
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "dispute-evidence-modal !tw-gap-0 !tw-z-[2000]",
    onOnClose: onClickBackButton,
    maxWidth: "100%",
    width: "588px",
    borderRadius: "8px",
    isShowCloseButton: true,
    isShowHeader: true,
    isTitleStrong: false,
    headerTitle: 
      props.dbsModalType === 'add'
        ? 'Add DBS (Police Check)'
        : 'Edit DBS (Police Check)'
    ,
    headerDescription: "Upload your valid DBS (Police Check) document in PDF, JPG, or PNG format, ensuring it is clear and legible for quicker verification.",
    headerDescriptionTextSize: "span",
    headerDescriptionLineHeight: "18px",
    gap: "0"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_form, {
            ref_key: "formRef",
            ref: formRef,
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
            rules: validation.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(Text, {
                      variant: "span",
                      lineHeight: "18px",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Issue Date")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_el_date_picker, {
                    class: "tw-min-h-[2.625rem] tw-max-h-[2.625rem] !tw-w-full",
                    type: "date",
                    placeholder: "Select Date",
                    "value-format": "DD-MM-YYYY",
                    format: _unref(DATE_FORMAT),
                    modelValue: issueDate.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((issueDate).value = $event)),
                    rules: validation.value.issueDate
                  }, null, 8, ["format", "modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(Text, {
                      variant: "span",
                      lineHeight: "18px",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Upload Attachments")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_v_file_input, {
                          class: _normalizeClass(["upload_file !tw-mb-0 !tw-bg-white", {
                          'added-img':
                            selectedAttachments.value && selectedAttachments.value?.length,
                        }]),
                          label: "Upload images & files",
                          variant: "solo-filled",
                          modelValue: selectedAttachments.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedAttachments).value = $event)),
                          rules: validation.value.attachments,
                          accept: ".jpg, .jpeg, .png, .pdf",
                          onChange: onFileChangeAttachments,
                          "prepend-icon": "mdi-file-image-box"
                        }, null, 8, ["modelValue", "rules", "class"])
                      ])
                    ]),
                    (selectedAttachments.value && selectedAttachments.value?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedAttachments.value, (file, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "attachment-item !tw-bg-none !tw-p-0 !tw-border-none"
                            }, [
                              _createElementVNode("div", _hoisted_12, [
                                (file.type === 'application/pdf')
                                  ? (_openBlock(), _createBlock(PdfIcon, {
                                      key: 0,
                                      class: "!tw-w-[14px] !tw-h-[12px] !tw-min-w-[14px]"
                                    }))
                                  : (_openBlock(), _createBlock(ImageIcon, {
                                      key: 1,
                                      class: "!tw-w-[14px] !tw-h-[12px] !tw-min-w-[14px]"
                                    })),
                                _createVNode(Text, {
                                  variant: "p",
                                  textWeight: "400"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(file.name), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createVNode(_component_v_icon, {
                                class: "cursor-pointer !tw-text-[16px]",
                                icon: "mdi-close",
                                onClick: ($event: any) => (removeAttachment(index))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(Text, {
                      variant: "xsmall",
                      class: "rmd:!tw-text-[14px]",
                      textColor: "rgba(12, 15, 74, 0.5)",
                      textWeight: "500",
                      lineHeight: "18px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Supported Formats for Attachments: JPG, PNG, PDF ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(Text, {
                    variant: "xsmall",
                    class: "rmd:!tw-text-[14px]",
                    textColor: "rgba(12, 15, 74, 0.5)",
                    textWeight: "500",
                    lineHeight: "18px"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Maximum File Size: 2MB ")
                    ]),
                    _: 1
                  })
                ]),
                (isFileUploading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_v_progress_linear, {
                        "model-value": uploadProgress.value,
                        height: 10,
                        width: 5,
                        striped: "",
                        rounded: "",
                        color: "#0C0F4A"
                      }, null, 8, ["model-value"]),
                      _createTextVNode(" " + _toDisplayString(uploadProgress.value) + " %", 1),
                      _hoisted_16
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_v_btn, {
                  class: "button button-purple-border",
                  onClick: onClickBackButton,
                  disabled: isUploadImg.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancel ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  class: "button button-purple",
                  disabled: 
                  props.dbsModalType === 'edit' && !selectedAttachments.value.length
                ,
                  onClick: onSubmit,
                  loading: isUploadImg.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.dbsModalType === "add" ? "Submit DBS Check" : "Update"), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ])
            ]),
            _: 1
          }, 8, ["rules"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["headerTitle"]))
}
}

})